<template lang="pug">
.ssp-data(v-if="frameStore.showSurface")
  div(v-for="rerun in frameStore.activeRerunsOrdered", :key="rerun")
    v-tile-layer(:animationLod="Store.config.tileLayer.animationLod", :lodBias="Store.config.tileLayer.lodBias", :cacheSize="Store.config.tileLayer.cacheSize")
      TextureProvider(:params="frameStore.params", :baseUrl="Env.hscMapData(rerun)")
</template>


<script lang="ts">
import Vue from 'vue'
import TextureProvider from "./TextureProvider";

export default Vue.extend({
  components: {
    TextureProvider,
  },
  props: {
    frameStore: { required: true },
  },
})
</script>